<template>
  <div>
    <template v-if="item.fromModel">
      <el-input v-if="minMax === true" v-model="value[item.fromModel][item.attrs.minLng]" placeholder="最小经度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.minLng], 'minLng')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.fromModel][item.attrs.minLat]" placeholder="最小纬度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.minLat], 'minLat')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.fromModel][item.attrs.maxLng]" placeholder="最大经度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.maxLng], 'maxLng')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.fromModel][item.attrs.maxLat]" placeholder="最大纬度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.maxLat], 'maxLat')">
      </el-input>
      <el-input v-if="lngLat === true" v-model="value[item.fromModel][item.attrs.lng]" placeholder="经度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.lng], 'lng')">
      </el-input>
      <el-input v-if="lngLat === true" v-model="value[item.fromModel][item.attrs.lat]" placeholder="纬度"
        class="bo-map__lnglat" @change="onChange(value[item.fromModel][item.attrs.lat], 'lat')">
      </el-input>
    </template>
    <template v-else>
      <el-input v-if="minMax === true" v-model="value[item.attrs.minLng]" placeholder="最小经度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.minLng], 'minLng')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.attrs.minLat]" placeholder="最小纬度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.minLat], 'minLat')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.attrs.maxLng]" placeholder="最大经度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.maxLng], 'maxLng')">
      </el-input>
      <el-input v-if="minMax === true" v-model="value[item.attrs.maxLat]" placeholder="最大纬度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.maxLat], 'maxLat')">
      </el-input>
      <el-input v-if="lngLat === true" v-model="value[item.attrs.lng]" placeholder="经度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.lng], 'lng')">
      </el-input>
      <el-input v-if="lngLat === true" v-model="value[item.attrs.lat]" placeholder="纬度" class="bo-map__lnglat"
        @change="onChange(value[item.attrs.lat], 'lat')">
      </el-input>
    </template>
    <el-button icon="el-icon-search" @click="handleOpenMap(item)"></el-button>

    <el-dialog v-dialogDrag :title="item.attrs.label" :visible="dialog.visible" @close="handleCloseDialog"
      :modal-append-to-body="false" top="10vh" width="70vw">
      <bo-map-item v-model="value" ref="bo-map-item" :id="refId" :item="item" style="width: 100%;height: 70vh;"
        @change="handleChange"></bo-map-item>
    </el-dialog>
  </div>
</template>
<style>
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .bo-map__lnglat {
    width: 150px;
    margin-left: 5px;
  }
</style>
<script>
  export default {
    name: "BoMap",
    components: {
      BoMapItem: () => import("./bo-map-item")
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        map: null
      };
    },
    props: {
      value: {
        type: Object
      },
      rowIndex: {
        type: Number,
        default: -1
      },
      item: {
        type: Object,
        default: function () {
          return {
            field: "",
            type: "bo-map",
            attrs: {
              showType: "lnglat", // lnglat minmax minmaxlnglat
              geoType: "point", //point/line/polygon
              geoName: null,
              lng: null,
              lat: null,
              minLng: null,
              minLat: null,
              maxLng: null,
              maxLat: null,
              maxZoom: 18,
              minZoom: 5,
              provider: "gaode"
            },
            events: {},
            params: {},
            methods: {}
          };
        }
      }
    },
    mounted() {},
    computed: {
      refId() {
        return this.item.field + Math.floor(Math.random() * 10000000);
      },
      lngLat() {
        return this.item.attrs.showType.includes("lnglat") === true;
      },
      minMax() {
        return this.item.attrs.showType.includes("minmax") === true;
      }
    },
    methods: {
      handleCloseDialog() {
        this.dialog.visible = false;
      },
      handleOpenMap(item) {
        this.dialog.visible = true;
        if (this.$refs["bo-map-item"]) {
          this.$refs["bo-map-item"].reload();
        }
      },
      handleChange(item, data) {
        this.handleChangeData(item,data);
      },
      onChange(val, field) {
        let data = {};
        if (field === "lat") {
          data.lat = val;
        } else if (field === "lng") {
          data.lng = val;
        } else if (field === "minLng") {
          data.minLng = val;
        } else if (field === "minLat") {
          data.minLat = val;
        } else if (field === "maxLng") {
          data.maxLng = val;
        } else if (field === "maxLat") {
          data.maxLat = val;
        }
        this.handleChangeData(this.item,data);
      },
      handleChangeData(item,data){
        if(this.rowIndex!==-1){
           this.$emit("change-row", item, this.rowIndex, data);
        }else{    
           this.$emit("change", item, data);      
        }
      }
    }
  };
</script>